import { VisionPage } from '../../components/Public/Vision'
import AboutUs from '../../assets/About Us.png'
import { Button } from '../../layouts/ui/Button'
import MetaData from '../../components/MetaData'

export const AboutPage = () => {
    return (
        <>
            <MetaData
                title="About CareerConnect AI | AI-Powered Job Matching Platform"
                description="Learn about CareerConnect AI - connecting exceptional talent with forward-thinking employers through innovative AI-powered recruitment solutions and matching technology."
                url="https://www.careerconnectai.com/about"
                keywords="about CareerConnect AI, recruitment, job matching, AI hiring, talent acquisition, employer solutions, careerconnect, careerconnect ai"
            />
            <main className='flex flex-col items-center px-4 md:px-8 lg:px-16 xl:px-24 py-10 overflow-x-hidden'>
                <section className=' w-full max-w-[1312px]   space-y-5'>
                    <div>
                        <h4 className='font-medium text-[20px]'>About Us <span className='bg-clip-text text-transparent bg-gradient-to-r from-[#2C25C4] to-[#8C18C3] '>– CareerConnectai.com</span></h4>

                        <div className="flex justify-center md:flex-row flex-col gap-9  items-center py-6 flex-wrap lg:flex-nowrap ">


                            <div className="bg-white w-full lg:w-[646px] lg:h-[400px] p-5 md:py-[36px] rounded-md">
                                <h2 className="font-semibold text-[20px] md:text-[28px] lg:text-[48px] text-[#3D3D3D] leading-tight">
                                    Connecting Talent with Opportunity
                                </h2>
                                <p className="text-[12px] md:text-[16px] lg:text-[20px] leading-normal py-4 md:py-[30px]">
                                    Bridging the gap between exceptional job seekers and forward-thinking
                                    employers through AI-powered matching and innovative recruitment solutions.
                                </p>

                                <div className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-8">
                                    {/* <Button
                                    variant="white"
                                    className="w-full sm:w-[200px] md:w-[200px] lg:w-[260px] h-[38px] sm:h-[44px] lg:h-[48px] text-sm md:text-[16px] text-[#2c25c4] border border-[#2C25C4]"
                                    onClick={() => alert('Get Started!')}
                                >
                                    Join as Employer
                                </Button> */}

                                    <Button
                                        variant="primary"
                                        className="w-full sm:w-[200px] md:w-[200px] lg:w-[260px] h-[38px] sm:h-[44px] lg:h-[48px] text-white text-sm md:text-[16px]"
                                        onClick={() => window.location.href = '/signup'}
                                    >
                                        Join as Job Seeker
                                    </Button>
                                </div>
                            </div>


                            <div className="w-full lg:w-[646px] lg:h-[400px]">
                                <img
                                    className="w-full h-full object-cover rounded-[12px]"
                                    src={AboutUs}
                                    alt="About Us"
                                />
                            </div>
                        </div>



                    </div>
                </section>
                <VisionPage />
            </main>
        </>
    )
}
